import React, { Component } from "react";
import "./ContentSummaryList.css";
import { Link } from "react-router-dom";

import { get } from "../../../utils/BeeApi";
import { slugify } from "../../../utils/StringUtils";

import Loader from "../../Loader/Loader";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";

class ContentSummaryList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.subscribedPromises = [];
  }

  componentDidMount() {
    this.fetchContents();
  }

  fetchContents() {
    const { limit, offset, operand, rank, category } = this.props;

    this.setState({
      error: "",
      isLoading: true
    });

    const options = {
      limit: limit || 20,
      offset: offset || 0,
      operand: operand || "or",
      rank: rank || null,
      category: category || null
    };
    const createPromise = get("/contents", { params: options });
    createPromise.promise
      .then(response => {
        this.setState({
          contentSummaryList: response.data,
          error: "",
          isLoading: false
        });
      })
      .catch(error => {
        !error.isCanceled &&
          this.setState({
            isLoading: false,
            error: error
          });
      });

    this.subscribedPromises.push(createPromise);
  }

  componentWillUnmount() {
    this.subscribedPromises.forEach(function(promise) {
      promise.cancel();
    });
  }

  render() {
    const { error, isLoading, contentSummaryList } = this.state;
    const URLPrefix = this.props.URLPrefix || "contents";

    if (error) return <ErrorHandler error={error} />;
    if (isLoading) return <Loader />;

    return (
      <div className="ContentSummaryList">
        <ul className="list-styled">
          {contentSummaryList &&
            contentSummaryList.map(content => {
              return (
                <li key={content.contentId} className="mt-xs mb-xs">
                  <p>
                    <i className="material-icons">bookmark</i>
                    <Link
                      className="hyperlink-1"
                      to={
                        "/" +
                        URLPrefix +
                        "/" +
                        content.contentId +
                        "/" +
                        slugify(content.title)
                      }
                    >
                      {content.title}
                    </Link>
                  </p>
                </li>
              );
            })}
        </ul>
      </div>
    );
  }
}

export default ContentSummaryList;
